/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  loginCheck: 是否需要登录验证
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
    { path: "/", redirect: "/home" },
    {
        path: "/",
        name: "Index",
        meta: {
            title: "泉港智慧停车",
            // keepAlive: true,
        },
        component: () => import("@/views/index"),
        children: [
            {
                path: "/home",
                name: "Home",
                meta: {
                    title: "泉港智慧停车",
                },
                component: () => import("@/views/home/index"),
            },
            {
                path: "/record",
                name: "Record",
                meta: {
                    title: "记录",
                },
                component: () => import("@/views/record/index"),
            },
            {
                path: "/parking",
                name: "Parking",
                meta: {
                    title: "停车",
                    keepAlive: true,
                },
                component: () => import("@/views/parking/index"),
            },
            {
                path: "/mine",
                name: "Mine",
                meta: {
                    title: "我的",
                },
                component: () => import("@/views/mine/index"),
            },

            {
                path: "/test",
                name: "test",
                mata: {
                    title: "测试",
                },
                component: () => import("@/views/record/recordDetail.vue"),
            },
        ],
    },

    // 个人信息
    {
        path: "/mine/userinfo",
        meta: {
            title: "个人信息",
        },
        component: () => import("@/views/mine/userInfo.vue"),
    },
    // 优惠认证
    {
        path: "/mine/preferentialCertification",
        meta: {
            title: "优惠认证",
        },
        component: () => import("@/views/mine/preferentialCertification/index.vue"),
    },

    // 添加优惠认证
    {
        path: "/mine/preferentialCertification/addCertification",
        meta: {
            title: "添加优惠认证",
        },
        component: () => import("@/views/mine/preferentialCertification/addCertification.vue"),
    },
    // 登录
    {
        path: "/login",
        meta: {
            title: "登录",
        },
        component: () => import("@/views/login/index.vue"),
    },
    // 记录详情
    {
        path: "/record/recordDetail",
        name: "RecordDetail",
        meta: {
            title: "订单详情",
        },
        component: () => import("@/views/record/recordDetail.vue"),
    },
    // wxAuth
    {
        path: "/wxAuth",
        meta: {
            title: "微信授权",
        },
        component: () => import("@/views/login/wxAuth.vue"),
    },
    {
        path: "/login/userAgreement",
        name: "userAgreement",
        meta: {
            title: "用户协议",
        },
        component: () => import("@/views/login/userAgreement.vue"),
    },

    // 停车场搜索
    {
        path: "/searchParkinglot",
        name: "SearchParkinglot",
        meta: {
            title: "停车场搜索",
        },
        component: () => import("@/views/home/searchParkinglot.vue"),
    },
    // 我的车辆
    {
        path: "/mycar",
        name: "Mycar",
        meta: {
            title: "我的车辆",
        },
        component: () => import("@/views/mycar/index.vue"),
    },

    {
        path: "/mycar/confidentialitySetting",
        name: "ConfidentialitySetting",
        meta: {
            title: "免密设置",
        },
        component: () => import("@/views/mycar/confidentialitySetting.vue"),
    },

    // 添加车辆
    {
        path: "/mycar/addcar",
        name: "AddCar",
        meta: {
            title: "添加车辆",
        },
        component: () => import("@/views/mycar/addCar.vue"),
    },
    // 充值
    {
        path: "/mine/recharge",
        name: "Recharge",
        meta: {
            title: "充值",
        },
        component: () => import("@/views/mine/recharge.vue"),
    },
    {
        path: "/mine/paymentRecharge",
        name: "paymentRecharge",
        meta: {
            title: "代付充值",
        },
        component: () => import("@/views/mine/paymentRecharge.vue"),
    },
    {
        path: "/mine/wallet",
        name: "Wallet",
        meta: {
            title: "余额",
        },
        component: () => import("@/views/mine/wallet.vue"),
    },
    {
        path: "/mine/paymentWallet",
        name: "paymentWallet",
        meta: {
            title: "代付余额",
        },
        component: () => import("@/views/mine/paymentWallet.vue"),
    },

    {
        path: "/mine/voucher",
        name: "Voucher",
        meta: {
            title: "优惠券",
        },
        component: () => import("@/views/mine/voucher.vue"),
    },

    // 车俩认证
    {
        path: "/mycar/vehicleCertification",
        name: "VehicleCertification",
        meta: {
            title: "车辆认证",
            // keepAlive: true,
        },
        component: () => import("@/views/mycar/vehicleCertification.vue"),
    },
    // 手机验证认证
    {
        path: "/mine/userinfo/verifyPhone",
        name: "VerifyPhone",
        meta: {
            title: "实名认证",
        },
        component: () => import("@/views/mine/verifyId/verifyPhone.vue"),
    },
    // 实名认证
    {
        path: "/mine/userinfo/verifyIdCard",
        name: "verifyIdCard",
        meta: {
            title: "实名认证",
            // keepAlive: true,
        },
        component: () => import("@/views/mine/verifyId/verifyIdCard.vue"),
    },
    // 认证协议
    {
        path: "/mine/verifyProtocol",
        name: "verifyProtocol",
        meta: {
            title: "认证协议",
        },
        component: () => import("@/views/mine/verifyProtocol.vue"),
    },
    // 手机验证认证验证码输入
    {
        path: "/mine/userinfo/verifyPhoneCode",
        name: "verifyPhoneCode",
        meta: {
            title: "实名认证",
        },
        component: () => import("@/views/mine/verifyId/verifyPhoneCode.vue"),
    },
    // 更换手机号码
    {
        path: "/mine/userinfo/changePhone",
        name: "ChangePhone",
        meta: {
            title: "更换手机号码",
        },
        component: () => import("@/views/mine/phone/changePhone.vue"),
    },
    // 更换新手机号码
    {
        path: "/mine/userinfo/changeNewPhone",
        name: "ChangeNewPhone",
        meta: {
            title: "更换手机号码",
        },
        component: () => import("@/views/mine/phone/changeNewPhone.vue"),
    },
    // 修改密码短信验证
    {
        path: "/mine/userinfo/changePassword",
        name: "ChangePassword",
        meta: {
            title: "修改登录密码",
        },
        component: () => import("@/views/mine/password/changePassword.vue"),
    },
    // 更换新密码
    {
        path: "/mine/userinfo/changeNewPassword",
        name: "ChangeNewPassword",
        meta: {
            title: "修改登录密码",
        },
        component: () => import("@/views/mine/password/changeNewPassword.vue"),
    },
    // 快捷缴费
    {
        path: "/pay/quickPay",
        meta: {
            title: "快捷缴费",
        },
        component: () => import("@/views/pay/quickPay.vue"),
    },
    // 快捷缴费
    {
        path: "/berthParking",
        meta: {
            title: "泊位停车",
        },
        component: () => import("@/views/berthParking/index.vue"),
    },
    // 云闪付 快捷缴费
    {
        path: "/unionPay/quickPay",
        meta: {
            title: "快捷缴费",
        },
        component: () => import("@/views/unionPay/quickPay.vue"),
    },
        {
        path: "/payByOthers",
        meta: {
            title: "代付",
        },
        component: () => import("@/views/unionPay/payByOthers.vue"),
    },
    // 停车缴费
    {
        path: "/pay/ParkingPay",
        name: "ParkingPay",
        meta: {
            title: "停车缴费",
        },
        component: () => import("@/views/pay/parkingPay.vue"),
    },

    // 云闪付 停车缴费
    {
        path: "/unionPay/ParkingPay",
        name: "ParkingunionPay",
        meta: {
            title: "停车缴费",
        },
        component: () => import("@/views/unionPay/parkingPay.vue"),
    },
    // 待缴费用
    {
        path: "/pay/waitPay",
        name: "WaitPay",
        meta: {
            title: "待缴费用",
        },
        component: () => import("@/views/pay/waitPay.vue"),
    },
    // 公告
    {
        path: "bulletin",
        name: "Bulletin",
        meta: {
            title: "公告",
        },
        component: () => import("@/views/bulletin/index.vue"),
    },
    // 支付成功
    {
        path: "/pay/payResult",
        name: "payResult",
        meta: {
            title: "支付结果",
        },
        component: () => import("@/views/pay/payResult.vue"),
    },

    {
        path: "/pay/goldPlanPayResult",
        name: "payResult",
        meta: {
            title: "支付结果",
        },
        component: () => import("@/views/pay/goldPlanPayResult.vue"),
    },
    // 停车账单
    {
        path: "/bill",
        name: "Bill",
        meta: {
            title: "停车账单",
        },
        component: () => import("@/views/bill/index.vue"),
    },

    // 发票
    {
        path: "/invoice",
        name: "Invoice",
        meta: {
            title: "电子发票",
        },
        component: () => import("@/views/invoice/index.vue"),
    },

    // 充值开票
    {
        path: "/invoice/invoiceRecharge",
        name: "InvoiceRecharge",
        meta: {
            title: "充值开票",
        },
        component: () => import("@/views/invoice/invoice-recharge.vue"),
    },
    // 停车卡开票
    {
        path: "/invoice/invoiceParkingCard",
        name: "InvoiceParkingCard",
        meta: {
            title: "停车卡开票",
        },
        component: () => import("@/views/invoice/invoice-parkingCard.vue"),
    },
    // 停车缴费开票
    {
        path: "/invoice/invoiceParking",
        name: "InvoiceParking",
        meta: {
            title: "停车缴费开票",
        },
        component: () => import("@/views/invoice/invoice-parking.vue"),
    },
    // 开票
    {
        path: "/invoice/invoiceCreate",
        name: "InvoiceCreate",
        meta: {
            title: "开票",
        },
        component: () => import("@/views/invoice/invoice-create.vue"),
    },
    // 开票成功
    {
        path: "/invoice/invoiceSuccess",
        name: "InvoiceSuccess",
        meta: {
            title: "开票成功",
        },
        component: () => import("@/views/invoice/invoice-success.vue"),
    },
    // 重发发票
    {
        path: "/invoice/invoiceResend",
        name: "InvoiceResend",
        meta: {
            title: "重发发票",
        },
        component: () => import("@/views/invoice/invoice-resend.vue"),
    },
    // 开票记录
    {
        path: "/invoice/record",
        name: "InvoiceRecord",
        meta: {
            title: "开票记录",
        },
        component: () => import("@/views/invoice/invoice-record.vue"),
    },
    // 发票详情
    {
        path: "/invoice/detail",
        name: "InvoiceDetail",
        meta: {
            title: "发票详情",
        },
        component: () => import("@/views/invoice/invoice-detail.vue"),
    },
    // 停车场分布
    {
        path: "/parking/search",
        name: "ParkingsSearch",
        meta: {
            title: "停车场分布",
        },
        component: () => import("@/views/parking/parking-search.vue"),
    },
    // 隐私服务
    {
        path: "/privacyService",
        name: "PrivacyService",
        meta: {
            title: "隐私服务",
        },
        component: () => import("@/views/privacyService.vue"),
    },

    // 客服帮助
    {
        path: "/suggestion",
        name: "Suggestion",
        meta: {
            title: "客服帮助",
        },
        component: () => import("@/views/suggestion/index.vue"),
    },

    // 订单申诉
    {
        path: "/suggestion/orderAppeal",
        name: "orderAppeal",
        meta: {
            title: "订单申诉",
        },
        component: () => import("@/views/suggestion/orderAppeal/index.vue"),
    },

    // 申诉详情
    {
        path: "/suggestion/orderAppeal/orderAppealDetail",
        name: "orderAppealDetail",
        meta: {
            title: "申诉详情",
        },
        component: () => import("@/views/suggestion/orderAppealDetail/index.vue"),
    },

    // 投诉建议
    {
        path: "/suggestion/complaintSuggestion",
        name: "complaintSuggestion",
        meta: {
            title: "投诉建议",
        },
        component: () => import("@/views/suggestion/complaintSuggestion/index.vue"),
    },

    // 申诉记录
    {
        path: "/suggestion/complainHtistory",
        name: "complainHtistory",
        meta: {
            title: "申诉记录",
        },
        component: () => import("@/views/suggestion/complainHtistory/index.vue"),
    },
    // 操作指南
    {
        path: "/operationGuide",
        name: "OperationGuide",
        meta: {
            title: "操作指南",
        },
        component: () => import("@/views/operationGuide/index.vue"),
    },
    // 操作指南关于退款
    {
        path: "/operationGuide/refund",
        name: "refund",
        meta: {
            title: "操作指南",
        },
        component: () => import("@/views/operationGuide/refund.vue"),
    },

    // 操作指南关于申诉
    {
        path: "/operationGuide/appeal",
        name: "operationGuideAppeal",
        meta: {
            title: "操作指南",
        },
        component: () => import("@/views/operationGuide/appeal.vue"),
    },
    // 操作指南详情
    {
        path: "/operationGuideDetail",
        name: "operationGuideDetail",
        meta: {
            title: "操作指南",
        },
        component: () => import("@/views/operationGuide/operationGuideDetail.vue"),
    },

    // 代付
    {
        path: "/carFarePayment",
        name: "carFarePayment",
        meta: {
            title: "车费代付",
        },
        component: () => import("@/views/carFarePayment/index.vue"),
    },
    {
        path: "/carFarePayment/paymentParkingRecords",
        name: "paymentParkingRecords",
        meta: {
            title: "停车代付",
        },
        component: () => import("@/views/carFarePayment/paymentParkingRecords.vue"),
    },
    // 虚拟列表
    {
        path: "/test/test",
        name: "test",
        meta: {
            title: "虚拟列表",
        },
        component: () => import("@/views/test/test.vue"),
    },
    {
        path: "*",
        meta: {
            title: "error",
            hideInMenu: true,
        },
        component: () => import("@/components/error/404.vue"),
    },
];
